module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "head",
    attrs: {
      "id": "ded"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/005_contents#rded"
    }
  }, [_vm._v("♦ DEDICATION ♦")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("This book is dedicated to")])]), _vm._v(" "), _c('p', {
    staticClass: "centera"
  }, [_c('em', [_vm._v("People who have lived checkered pasts")])]), _vm._v(" "), _c('p', {
    staticClass: "centera"
  }, [_c('em', [_vm._v("Your past is does not define, nor does it dictate your future.")])]), _vm._v(" "), _c('p', {
    staticClass: "indentt"
  }, [_c('em', [_vm._v("“Though no one can go back and make a brand new start, anyone can start from now and make a brand new ending.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("- Carl Bard")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10e715e7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/006_dedication.vue
// module id = 69
// module chunks = 0